import React, { lazy } from 'react';
import { Switch } from 'react-router-dom';
import './style.scss';
import { FallbackProvider } from './components/core/LazyLoad/FallbackProvider';

// const SentryErrorBoundary = lazy(() => import('./components/error/sentryErrorBoundary'));


const PrivateRoute = lazy(() => import('./components/core/PrivateRoute'));
const PciPalPage = lazy(() => import('./components/PCIPAL/LandingPage/Pcipal'));

export function PciPalApp() {
    return (
        <FallbackProvider>
            <div className='paymentsSelfContainer'>
                <Switch>
                    <PrivateRoute path='/:country/:id' exact component={PciPalPage} />
                </Switch>
            </div>
        </FallbackProvider>
    );
}

export default function App() {
    return <PciPalApp/>;
}
